module.exports = __webpack_public_path__ + "img/ic-home.afdc56f9.svg";